import NotFoundPage from '@/views/notFound';
import Home from '@/views/home';
import Result from '@/views/result';
import ResultGs from '@/views/resultGs';
import Aboutus from '@/views/aboutus';
import MHome from '@/views/m/home';
import MResult from '@/views/m/result';
import MResultGs from '@/views/m/resultGs';
import MAboutus from '@/views/m/aboutus';
import MDownloadpage from '@/views/m/downloadPage';
import HkzkDownloadpage from '@/views/m/downloadPageHkzk';
import Selectdownloadpage from '@/views/m/selectDownload';

const router = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/result',
    element: <Result />,
  },
  {
    path: '/resultgs',
    element: <ResultGs />,
  },
  {
    path: '/aboutus',
    element: <Aboutus />,
  },
  {
    path: '/m',
    children: [
      {
        path: '/m/home',
        element: <MHome />,
      },
      {
        path: '/m/result',
        element: <MResult />,
      },
      {
        path: '/m/resultGs',
        element: <MResultGs />,
      },
      {
        path: '/m/aboutus',
        element: <MAboutus />,
      },
      {
        path: '/m/downloadpage',
        element: <MDownloadpage />,
      },
      {
        path: '/m/hkzkdownloadpage',
        element: <HkzkDownloadpage />,
      },
      {
        path: '/m/selectdownloadpage',
        element: <Selectdownloadpage />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default router;
